export default __webpack_public_path__ + "static/media/flowervines.416a57d7.png";